export const DEFAULT_API_HOSTNAME = "api.workos.com";
export const API_ENDPOINTS = {
  USERS: "_widgets/UserManagement/members",
  USER_ROLES: "_widgets/UserManagement/roles",
  USER_INVITE: "_widgets/UserManagement/invite-user",
  USER_INVITES: "_widgets/UserManagement/invites",
  USER_INVITES_RESEND: (userId: string) =>
    `_widgets/UserManagement/invites/${userId}/resend`,
};
